import { mapStudentFromApi } from '../../utils/studentResolution';
import { entityKey, rosterKey } from '../ids';

/**
 * Canonical student roster entry for workspace store.
 */
export function normalizeStudentEntity(rawStudent, schoolId, branchId) {
  const mapped = mapStudentFromApi(rawStudent, schoolId, branchId);
  return {
    ...mapped,
    id: entityKey(mapped.id),
    schoolId: entityKey(mapped.schoolId),
    branchId: mapped.branchId ? entityKey(mapped.branchId) : '',
  };
}

export function normalizeRosterStudents(rawStudents, schoolId, branchId) {
  return (rawStudents || []).map(s => normalizeStudentEntity(s, schoolId, branchId));
}

export { rosterKey };